import {
	FAILED_TO_RECEIVE_APPLICATION_IPT, FAILED_TO_RECEIVE_APPLICATIONS_SCHEDULES, GET_APPLICATION_IPT,
	GET_APPLICATIONS_SCHEDULES,
	RECEIVE_APPLICATION_IPT, RECEIVE_APPLICATIONS_SCHEDULES,
	
} from "./index";

//action that requests get the IPT of an application
export function getApplicationIpt(applicationId) {
	return {
		type: GET_APPLICATION_IPT,
		payload: applicationId
	};
}

//action that receives IPT of an application
export function receiveApplicationIpt(ipt) {
	return {
		type: RECEIVE_APPLICATION_IPT,
		payload: ipt
	};
}

//action that receives failed response getting the ipt of an application
export function failedToReceiveApplicationIpt(response) {
	return {
		type: FAILED_TO_RECEIVE_APPLICATION_IPT,
		payload: response
	}
}

//action that requests get the schedules of the applications
export function getApplicationsSchedules() {
	return {
		type: GET_APPLICATIONS_SCHEDULES
	};
}

//action that receives the applications schedules
export function receiveApplicationsSchedules(schedules) {
	return {
		type: RECEIVE_APPLICATIONS_SCHEDULES,
		payload: schedules
	}
}

//action that receives failed response getting the applications schedules
export function failedToReceiveApplicationsSchedules(response) {
	return {
		type: FAILED_TO_RECEIVE_APPLICATIONS_SCHEDULES,
		payload: response
	}
}
